function getFocusableElements(t) {
	return Array.from(t.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"))
}
document.querySelectorAll('[id^="Details-"] summary').forEach((t => {
	t.setAttribute("role", "button"), t.setAttribute("aria-expanded", t.parentNode.hasAttribute("open")), t.nextElementSibling.getAttribute("id") && t.setAttribute("aria-controls", t.nextElementSibling.id), t.addEventListener("click", (t => {
		t.currentTarget.setAttribute("aria-expanded", !t.currentTarget.closest("details").hasAttribute("open"))
	})), t.closest("header-drawer") || t.parentElement.addEventListener("keyup", onKeyUpEscape)
}));
const trapFocusHandlers = {};

function trapFocus(t, e = t) {
	var i = getFocusableElements(t),
		s = i[0],
		r = i[i.length - 1];
	removeTrapFocus(), trapFocusHandlers.focusin = e => {
		e.target !== t && e.target !== r && e.target !== s || document.addEventListener("keydown", trapFocusHandlers.keydown)
	}, trapFocusHandlers.focusout = function() {
		document.removeEventListener("keydown", trapFocusHandlers.keydown)
	}, trapFocusHandlers.keydown = function(e) {
		"TAB" === e.code.toUpperCase() && (e.target !== r || e.shiftKey || (e.preventDefault(), s.focus()), e.target !== t && e.target !== s || !e.shiftKey || (e.preventDefault(), r.focus()))
	}, document.addEventListener("focusout", trapFocusHandlers.focusout), document.addEventListener("focusin", trapFocusHandlers.focusin), e.focus()
}
try {
	document.querySelector(":focus-visible")
} catch (t) {
	focusVisiblePolyfill()
}

function focusVisiblePolyfill() {
	const t = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"];
	let e = null,
		i = null;
	window.addEventListener("keydown", (e => {
		t.includes(e.code.toUpperCase()) && (i = !1)
	})), window.addEventListener("mousedown", (t => {
		i = !0
	})), window.addEventListener("focus", (() => {
		e && e.classList.remove("focused"), i || (e = document.activeElement, e.classList.add("focused"))
	}), !0)
}

function pauseAllMedia() {
	document.querySelectorAll(".js-youtube").forEach((t => {
		t.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*")
	})), document.querySelectorAll(".js-vimeo").forEach((t => {
		t.contentWindow.postMessage('{"method":"pause"}', "*")
	})), document.querySelectorAll("video").forEach((t => t.pause())), document.querySelectorAll("product-model").forEach((t => {
		t.modelViewerUI && t.modelViewerUI.pause()
	}))
}

function removeTrapFocus(t = null) {
	document.removeEventListener("focusin", trapFocusHandlers.focusin), document.removeEventListener("focusout", trapFocusHandlers.focusout), document.removeEventListener("keydown", trapFocusHandlers.keydown), t && t.focus()
}

function onKeyUpEscape(t) {
	if ("ESCAPE" !== t.code.toUpperCase()) return;
	const e = t.target.closest("details[open]");
	if (!e) return;
	const i = e.querySelector("summary");
	e.removeAttribute("open"), i.setAttribute("aria-expanded", !1), i.focus()
}
class QuantityInput extends HTMLElement {
	constructor() {
		super(), this.input = this.querySelector("input"), this.changeEvent = new Event("change", {
			bubbles: !0
		}), this.querySelectorAll("button").forEach((t => t.addEventListener("click", this.onButtonClick.bind(this))))
	}
	onButtonClick(t) {
		t.preventDefault();
		const e = this.input.value;
		"plus" === t.target.name ? this.input.stepUp() : this.input.stepDown(), e !== this.input.value && this.input.dispatchEvent(this.changeEvent)
	}
}

function debounce(t, e) {
	let i;
	return (...s) => {
		clearTimeout(i), i = setTimeout((() => t.apply(this, s)), e)
	}
}

function fetchConfig(t = "json") {
	return {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: `application/${t}`
		}
	}
}
customElements.define("quantity-input", QuantityInput), void 0 === window.Shopify && (window.Shopify = {}), Shopify.bind = function(t, e) {
	return function() {
		return t.apply(e, arguments)
	}
}, Shopify.setSelectorByValue = function(t, e) {
	for (var i = 0, s = t.options.length; i < s; i++) {
		var r = t.options[i];
		if (e == r.value || e == r.innerHTML) return t.selectedIndex = i, i
	}
}, Shopify.addListener = function(t, e, i) {
	t.addEventListener ? t.addEventListener(e, i, !1) : t.attachEvent("on" + e, i)
}, Shopify.postLink = function(t, e) {
	var i = (e = e || {}).method || "post",
		s = e.parameters || {},
		r = document.createElement("form");
	for (var o in r.setAttribute("method", i), r.setAttribute("action", t), s) {
		var n = document.createElement("input");
		n.setAttribute("type", "hidden"), n.setAttribute("name", o), n.setAttribute("value", s[o]), r.appendChild(n)
	}
	document.body.appendChild(r), r.submit(), document.body.removeChild(r)
}, Shopify.CountryProvinceSelector = function(t, e, i) {
	this.countryEl = document.getElementById(t), this.provinceEl = document.getElementById(e), this.provinceContainer = document.getElementById(i.hideElement || e), Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)), this.initCountry(), this.initProvince()
}, Shopify.CountryProvinceSelector.prototype = {
	initCountry: function() {
		var t = this.countryEl.getAttribute("data-default");
		Shopify.setSelectorByValue(this.countryEl, t), this.countryHandler()
	},
	initProvince: function() {
		var t = this.provinceEl.getAttribute("data-default");
		t && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, t)
	},
	countryHandler: function(t) {
		var e = (r = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),
			i = JSON.parse(e);
		if (this.clearOptions(this.provinceEl), i && 0 == i.length) this.provinceContainer.style.display = "none";
		else {
			for (var s = 0; s < i.length; s++) {
				var r;
				(r = document.createElement("option")).value = i[s][0], r.innerHTML = i[s][1], this.provinceEl.appendChild(r)
			}
			this.provinceContainer.style.display = ""
		}
	},
	clearOptions: function(t) {
		for (; t.firstChild;) t.removeChild(t.firstChild)
	},
	setOptions: function(t, e) {
		var i = 0;
		for (e.length; i < e.length; i++) {
			var s = document.createElement("option");
			s.value = e[i], s.innerHTML = e[i], t.appendChild(s)
		}
	}
};
class MenuDrawer extends HTMLElement {
	constructor() {
		super(), this.mainDetailsToggle = this.querySelector("details"), "iPhone" === navigator.platform && document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`), this.addEventListener("keyup", this.onKeyUp.bind(this)), this.addEventListener("focusout", this.onFocusOut.bind(this)), this.bindEvents()
	}
	bindEvents() {
		this.querySelectorAll("summary").forEach((t => t.addEventListener("click", this.onSummaryClick.bind(this)))), this.querySelectorAll("button:not(.localization-form__select)").forEach((t => t.addEventListener("click", this.onCloseButtonClick.bind(this))))
	}
	onKeyUp(t) {
		if ("ESCAPE" !== t.code.toUpperCase()) return;
		const e = t.target.closest("details[open]");
		e && (e === this.mainDetailsToggle ? this.closeMenuDrawer(t, this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(e))
	}
	onSummaryClick(t) {
		const e = t.currentTarget,
			i = e.parentNode,
			s = i.closest(".has-submenu"),
			r = i.hasAttribute("open"),
			o = window.matchMedia("(prefers-reduced-motion: reduce)");

		function n() {
			trapFocus(e.nextElementSibling, i.querySelector("button")), e.nextElementSibling.removeEventListener("transitionend", n)
		}
		i === this.mainDetailsToggle ? (r && t.preventDefault(), r ? this.closeMenuDrawer(t, e) : this.openMenuDrawer(e)) : setTimeout((() => {
			i.classList.add("menu-opening"), e.setAttribute("aria-expanded", !0), s && s.classList.add("submenu-open"), !o || o.matches ? n() : e.nextElementSibling.addEventListener("transitionend", n)
		}), 100)
	}
	openMenuDrawer(t) {
		setTimeout((() => {
			this.mainDetailsToggle.classList.add("menu-opening")
		})), t.setAttribute("aria-expanded", !0), trapFocus(this.mainDetailsToggle, t), document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
	}
	closeMenuDrawer(t, e = !1) {
		void 0 !== t && (this.mainDetailsToggle.classList.remove("menu-opening"), this.mainDetailsToggle.querySelectorAll("details").forEach((t => {
			t.removeAttribute("open"), t.classList.remove("menu-opening")
		})), this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((t => {
			t.classList.remove("submenu-open")
		})), document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`), removeTrapFocus(e), this.closeAnimation(this.mainDetailsToggle))
	}
	onFocusOut(t) {
		setTimeout((() => {
			this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement) && this.closeMenuDrawer()
		}))
	}
	onCloseButtonClick(t) {
		const e = t.currentTarget.closest("details");
		this.closeSubmenu(e)
	}
	closeSubmenu(t) {
		const e = t.closest(".submenu-open");
		e && e.classList.remove("submenu-open"), t.classList.remove("menu-opening"), t.querySelector("summary").setAttribute("aria-expanded", !1), removeTrapFocus(t.querySelector("summary")), this.closeAnimation(t)
	}
	closeAnimation(t) {
		let e;
		const i = s => {
			void 0 === e && (e = s);
			s - e < 400 ? window.requestAnimationFrame(i) : (t.removeAttribute("open"), t.closest("details[open]") && trapFocus(t.closest("details[open]"), t.querySelector("summary")))
		};
		window.requestAnimationFrame(i)
	}
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
	constructor() {
		super()
	}
	openMenuDrawer(t) {
		this.header = this.header || document.querySelector(".excens-header-js"), this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0, document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom-this.borderOffset)}px`), this.header.classList.add("menu-open"), setTimeout((() => {
			this.mainDetailsToggle.classList.add("menu-opening")
		})), t.setAttribute("aria-expanded", !0), trapFocus(this.mainDetailsToggle, t), document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
	}
	closeMenuDrawer(t, e) {
		super.closeMenuDrawer(t, e), this.header.classList.remove("menu-open")
	}
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
	constructor() {
		super(), this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, !1)), this.addEventListener("keyup", (t => {
			"ESCAPE" === t.code.toUpperCase() && this.hide()
		})), this.classList.contains("media-modal") ? this.addEventListener("pointerup", (t => {
			"mouse" !== t.pointerType || t.target.closest("deferred-media, product-model") || this.hide()
		})) : this.addEventListener("click", (t => {
			t.target === this && this.hide()
		}))
	}
	connectedCallback() {
		this.moved || (this.moved = !0, document.body.appendChild(this))
	}
	show(t) {
		this.openedBy = t;
		const e = this.querySelector(".template-popup");
		document.body.classList.add("overflow-hidden"), this.setAttribute("open", ""), e && e.loadContent(), trapFocus(this, this.querySelector('[role="dialog"]')), window.pauseAllMedia();
		const deferredMedia = this.querySelector("deferred-media");
		if (deferredMedia && !deferredMedia.getAttribute("loaded")) {
			deferredMedia.loadContent(false);
		}
	}
	hide() {
		document.body.classList.remove("overflow-hidden"), document.body.dispatchEvent(new CustomEvent("modalClosed")), this.removeAttribute("open"), removeTrapFocus(this.openedBy), window.pauseAllMedia()
	}
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
	constructor() {
		super();
		const t = this.querySelector("button");
		t && t.addEventListener("click", (() => {
			console.log('not a test.');
			const e = document.querySelector(this.getAttribute("data-modal"));
			console.log(this.getAttribute("data-modal"));
			e && e.show(t)
		}))
	}
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		const t = this.querySelector('[id^="Deferred-Poster-"]');
		t && t.addEventListener("click", this.loadContent.bind(this))
	}
	loadContent(t = !0) {
		if (window.pauseAllMedia(), !this.getAttribute("loaded")) {
			const e = document.createElement("div");
			e.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)), this.setAttribute("loaded", !0);
			const i = this.appendChild(e.querySelector("video, model-viewer, iframe"));
			t && i.focus()
		}
	}
}
customElements.define("deferred-media", DeferredMedia);
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();
		new IntersectionObserver(((t, e) => {
			t[0].isIntersecting && (e.unobserve(this), fetch(this.dataset.url).then((t => t.text())).then((t => {
				const e = document.createElement("div");
				e.innerHTML = t;
				const i = e.querySelector("product-recommendations");
				if (i && i.innerHTML.trim().length) {
					this.innerHTML = i.innerHTML;
					let t = this.querySelector("[data-slider-component]");
					if (t) {
						const e = document.createElement("slider-component");
						e.classList.add("slider-mobile-gutter"), e.dataset.sliderComponent = "", e.innerHTML = t.innerHTML, t.parentNode.replaceChild(e, t), t = this.querySelector("[data-slider-component]"), t.dataset.sliderComponentAsync = !0
					}
				}
				e.querySelector(".grid__item") && this.classList.add("product-recommendations--loaded")
			})).catch((t => {
				console.error(t)
			})))
		}).bind(this), {
			rootMargin: "0px 0px 200px 0px"
		}).observe(this)
	}
}
customElements.define("product-recommendations", ProductRecommendations);
class SliderComponent extends HTMLElement {
	constructor() {
		super(), this.slider = this.querySelector('[id^="Slider-"]'), this.slider ? this.init() : setTimeout((() => {
			this.init()
		}), 100)
	}
	init() {
		if (this.slider = this.querySelector('[id^="Slider-"]'), !this.slider) return;
		if ("SLIDER-COMPONENT" == this.tagName ? this.sliderItems = this.querySelectorAll('[id^="Slide-"]:not([data-swatch-button])') : this.sliderItems = this.querySelectorAll('[id^="Slide-"]'), this.enableSliderLooping = !1, this.currentPageElement = this.querySelector(".slider-counter--current"), this.pageTotalElement = this.querySelector(".slider-counter--total"), this.prevButton = this.querySelector('button[name="previous"]'), this.nextButton = this.querySelector('button[name="next"]'), this.tabs = this.querySelectorAll("[data-tab]"), !this.slider || !this.nextButton) return;
		this.initPages();
		new ResizeObserver((t => this.initPages())).observe(this.slider), this.slider.addEventListener("scroll", this.update.bind(this)), this.prevButton.addEventListener("click", this.onButtonClick.bind(this)), this.nextButton.addEventListener("click", this.onButtonClick.bind(this)), this.tabs?.length && this.tabs.forEach((t => t.addEventListener("click", this.onTabClick.bind(this))))
	}
	onTabClick(t) {
		const e = t.currentTarget.dataset.tab;
		let i = !1;
		this.tabs.forEach((e => {
			e != t.currentTarget ? e.classList.remove("is-active") : e.classList.add("is-active")
		})), this.sliderItems.forEach((t => {
			t.dataset.filterTags.includes(e) || "view-all" === e ? (t.style.display = "block", i ? t.classList.remove("slider__slide--first-slide") : (t.classList.add("slider__slide--first-slide"), i = !0)) : (t.style.display = "none", t.classList.remove("slider__slide--first-slide"))
		}))
	}
	initPages() {
		this.sliderItemsToShow = Array.from(this.sliderItems).filter((t => t.clientWidth > 0)), this.sliderItemsToShow.length < 2 || (this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft, this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset), this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1, this.update())
	}
	resetPages() {
		this.sliderItems = this.querySelectorAll('[id^="Slide-"]'), this.initPages()
	}
	update() {
		const t = this.currentPage;
		this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1, this.currentPageElement && this.pageTotalElement && (this.currentPageElement.textContent = this.currentPage, this.pageTotalElement.textContent = this.totalPages), this.currentPage != t && this.dispatchEvent(new CustomEvent("slideChanged", {
			detail: {
				currentPage: this.currentPage,
				currentElement: this.sliderItemsToShow[this.currentPage - 1]
			}
		})), this.enableSliderLooping || (this.isSlideVisible(this.sliderItemsToShow[0]) && 0 === this.slider.scrollLeft ? this.prevButton.setAttribute("disabled", "disabled") : this.prevButton.removeAttribute("disabled"), this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1]) ? this.nextButton.setAttribute("disabled", "disabled") : this.nextButton.removeAttribute("disabled"))
	}
	isSlideVisible(t, e = 0) {
		const i = this.slider.clientWidth + this.slider.scrollLeft - e;
		return t.offsetLeft + t.clientWidth <= i && t.offsetLeft >= this.slider.scrollLeft
	}
	onButtonClick(t) {
		t.preventDefault();
		const e = t.currentTarget.dataset.step || 1;
		this.slideScrollPosition = "next" === t.currentTarget.name ? this.slider.scrollLeft + e * this.sliderItemOffset : this.slider.scrollLeft - e * this.sliderItemOffset, this.slider.scrollTo({
			left: this.slideScrollPosition
		})
	}
}
customElements.define("slider-component", SliderComponent);
class SwatchesSliderComponent extends SliderComponent {
	constructor() {
		super(), this.swatchButtons = this.querySelectorAll("[data-swatch-button]"), this.swatchButtons.forEach((t => t.addEventListener("click", this.onSwatchClick.bind(this)))), this.swatchesList = this.querySelector("[data-swatches-list]")
	}
	onSwatchClick(t) {
		const e = t.currentTarget.closest(".card"),
			i = t.currentTarget.dataset.color;
		if (e.querySelector(".card__img-link--no-colors")) return void console.error("missing images for color variantes");
		t.currentTarget.closest("[data-swatches]").querySelectorAll("[data-swatch-button]").forEach((t => {
			t.dataset.color == i ? t.classList.add("card__swatches__item--active") : t.classList.remove("card__swatches__item--active")
		}));
		e.querySelectorAll("[data-color-images]").forEach((t => {
			t.dataset.colorImages == i ? t.classList.add("card__img-link--active") : t.classList.remove("card__img-link--active")
		}));
		const s = e.querySelector("[data-product-link]");
		s.href = `${s.dataset.productLink}?variant=${t.currentTarget.dataset.variant}`
	}
	initPages() {
		this.sliderItemsToShow = Array.from(this.sliderItems).filter((t => t.clientWidth > 0)), this.sliderItemsToShow.length < 2 || (this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft, this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset), this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1, this.swatchesList && this.classList.add("pages-" + this.totalPages), this.totalPages > 1 && this.classList.remove("card__swatches--no-carousel"), this.update())
	}
}
customElements.define("swatches-slider-component", SwatchesSliderComponent);
class SlideshowComponent extends SliderComponent {
	constructor() {
		super(), this.sliderControlWrapper = this.querySelector(".slider-buttons"), this.enableSliderLooping = !0, this.sliderControlWrapper && (this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide"), this.sliderItemsToShow.length > 0 && (this.currentPage = 1), this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link")), this.sliderControlLinksArray.forEach((t => t.addEventListener("click", this.linkToSlide.bind(this)))), this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this)), this.setSlideVisibility(), "true" === this.slider.getAttribute("data-autoplay") && this.setAutoPlay())
	}
	setAutoPlay() {
		this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay"), this.autoplaySpeed = 1e3 * this.slider.dataset.speed, this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this)), this.addEventListener("mouseover", this.focusInHandling.bind(this)), this.addEventListener("mouseleave", this.focusOutHandling.bind(this)), this.addEventListener("focusin", this.focusInHandling.bind(this)), this.addEventListener("focusout", this.focusOutHandling.bind(this)), this.play(), this.autoplayButtonIsSetToPlay = !0
	}
	onButtonClick(t) {
		super.onButtonClick(t);
		const e = 1 === this.currentPage,
			i = this.currentPage === this.sliderItemsToShow.length;
		(e || i) && (e && "previous" === t.currentTarget.name ? this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length : i && "next" === t.currentTarget.name && (this.slideScrollPosition = 0), this.slider.scrollTo({
			left: this.slideScrollPosition
		}))
	}
	update() {
		super.update(), this.sliderControlButtons = this.querySelectorAll(".slider-counter__link"), this.prevButton.removeAttribute("disabled"), this.sliderControlButtons.length && (this.sliderControlButtons.forEach((t => {
			t.classList.remove("slider-counter__link--active"), t.removeAttribute("aria-current")
		})), this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active"), this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", !0))
	}
	autoPlayToggle() {
		this.togglePlayButtonState(this.autoplayButtonIsSetToPlay), this.autoplayButtonIsSetToPlay ? this.pause() : this.play(), this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay
	}
	focusOutHandling(t) {
		const e = t.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(t.target);
		this.autoplayButtonIsSetToPlay && !e && this.play()
	}
	focusInHandling(t) {
		(t.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(t.target)) && this.autoplayButtonIsSetToPlay ? this.play() : this.autoplayButtonIsSetToPlay && this.pause()
	}
	play() {
		this.slider.setAttribute("aria-live", "off"), clearInterval(this.autoplay), this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed)
	}
	pause() {
		this.slider.setAttribute("aria-live", "polite"), clearInterval(this.autoplay)
	}
	togglePlayButtonState(t) {
		t ? (this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused"), this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow)) : (this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused"), this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow))
	}
	autoRotateSlides() {
		const t = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector(".slideshow__slide").clientWidth;
		this.slider.scrollTo({
			left: t
		})
	}
	setSlideVisibility() {
		this.sliderItemsToShow.forEach(((t, e) => {
			const i = t.querySelector("a");
			e === this.currentPage - 1 ? (i && i.removeAttribute("tabindex"), t.setAttribute("aria-hidden", "false"), t.removeAttribute("tabindex")) : (i && i.setAttribute("tabindex", "-1"), t.setAttribute("aria-hidden", "true"), t.setAttribute("tabindex", "-1"))
		}))
	}
	linkToSlide(t) {
		t.preventDefault();
		const e = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(t.currentTarget) + 1 - this.currentPage);
		this.slider.scrollTo({
			left: e
		})
	}
}
customElements.define("slideshow-component", SlideshowComponent);
class Swatches extends HTMLElement {
	constructor() {
		super(), this.swatchButtons = this.querySelectorAll("[data-swatch-button]"), this.swatchButtons.forEach((t => t.addEventListener("click", this.onSwatchClick.bind(this))))
	}
	onSwatchClick(t) {
		const e = t.currentTarget.closest(".card"),
			i = t.currentTarget.dataset.color;
		if (e.querySelector(".card__img-link--no-colors")) return void console.error("missing images for color variantes");
		t.currentTarget.closest("[data-swatches]").querySelectorAll("[data-swatch-button]").forEach((t => {
			t.dataset.color == i ? t.classList.add("card__swatches__item--active") : t.classList.remove("card__swatches__item--active")
		}));
		e.querySelectorAll("[data-color-images]").forEach((t => {
			t.dataset.colorImages == i ? t.classList.add("card__img-link--active") : t.classList.remove("card__img-link--active")
		}));
		const s = e.querySelector("[data-product-link]");
		s.href = `${s.dataset.productLink}?variant=${t.currentTarget.dataset.variant}`
	}
}
customElements.define("color-swatches", Swatches);
class VariantSelects extends HTMLElement {
	constructor() {
		super(), this.addEventListener("change", this.onVariantChange)
	}
	onVariantChange() {
		this.updateOptions(), this.updateMasterId(), this.toggleAddButton(!0, "", !1), this.updatePickupAvailability(), this.removeErrorMessage(), this.currentVariant ? (this.updateMedia(), this.updateURL(), this.updateVariantInput(), this.renderProductInfo(), this.updateShareUrl()) : (this.toggleAddButton(!0, "", !0), this.setUnavailable())
	}
	updateOptions() {
		this.options = Array.from(this.querySelectorAll("select"), (t => t.value))
	}
	updateMasterId() {
		this.currentVariant = this.getVariantData().find((t => !t.options.map(((t, e) => this.options[e] === t)).includes(!1)))
	}
	updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
  
    // Actualizar galería principal
    const gallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if (gallery && gallery.setActiveMedia) {
      gallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      );
    }
  
    // Buscar contenedor del modal
    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
  
    // Buscar media en el modal
    let mediaEl = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
  
    // 🚀 Si no existe, clonamos desde la galería principal
    if (!mediaEl) {
      const galleryEl = document.querySelector(
        `#MediaGallery-${this.dataset.section} [data-media-id="${this.currentVariant.featured_media.id}"]`
      );
      if (galleryEl) {
        mediaEl = galleryEl.cloneNode(true);
      }
    }
  
    // Insertar la media en el modal
    if (mediaEl) {
      modalContent.prepend(mediaEl);
    }
  }
	updateURL() {
		this.currentVariant && "false" !== this.dataset.updateUrl && window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`)
	}
	updateShareUrl() {
		const t = document.getElementById(`Share-${this.dataset.section}`);
		t && t.updateUrl && t.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`)
	}
	updateVariantInput() {
		document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`).forEach((t => {
			const e = t.querySelector('input[name="id"]');
			e.value = this.currentVariant.id, e.dispatchEvent(new Event("change", {
				bubbles: !0
			}))
		}))
	}
	updatePickupAvailability() {
		const t = document.querySelector("pickup-availability");
		t && (this.currentVariant && this.currentVariant.available ? t.fetchAvailability(this.currentVariant.id) : (t.removeAttribute("available"), t.innerHTML = ""))
	}
	removeErrorMessage() {
		const t = this.closest("section");
		if (!t) return;
		const e = t.querySelector("product-form");
		e && e.handleErrorMessage()
	}
	renderProductInfo() {
		fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection?this.dataset.originalSection:this.dataset.section}`).then((t => t.text())).then((t => {
			const e = (new DOMParser).parseFromString(t, "text/html");
			if (document.querySelectorAll("[data-price-box]")) {
				const t = document.querySelectorAll(`#price-${this.dataset.section}`);
				for (const i of t) {
					const t = e.querySelectorAll(`#price-${this.dataset.originalSection?this.dataset.originalSection:this.dataset.section}`);
					for (const e of t) {
						e && i && (i.innerHTML = e.innerHTML);
						const t = document.querySelectorAll(`#price-${this.dataset.section}`);
						for (const e of t) e && e.classList.remove("visibility-hidden"), this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut)
					}
				}
			}
		}))
	}
	toggleAddButton(t = !0, e, i = !0) {
		const s = document.getElementById(`product-form-${this.dataset.section}`);
		if (!s) return;
		const r = s.querySelector('[name="add"]'),
			o = s.querySelector('[name="add"] > span'),
			n = document.querySelector("[data-stock-msg]"),
			a = window.productPageStrings.securityStock,
			l = window.productPageStrings.stockMsg,
			d = l.replace("%_value_%", variantStock[this.currentVariant.id]),
			c = l.replace("%_value_%", "0");
		if (!r) return;
		t ? (r.setAttribute("disabled", "disabled"), e && (o.textContent = e), n && 0 == variantStock[this.currentVariant.id] && (n.classList.remove("is-hidden"), n.textContent = c)) : (r.removeAttribute("disabled"), o.textContent = window.variantStrings.addToCart, n && variantStock[this.currentVariant.id] > 0 && variantStock[this.currentVariant.id] <= a ? (n.textContent = d, n.classList.remove("is-hidden")) : n && variantStock[this.currentVariant.id] >= a && (n.classList.add("is-hidden"), n.textContent = d));
		const u = document.querySelector("[data-button-add]"),
			h = window.Shopify.locale,
			m = window.Shopify.currency.active,
			p = (this.currentVariant.price / 100).toLocaleString(h, {
				style: "currency",
				currency: m
			});
		u.innerHTML = p
	}
	setUnavailable() {
		const t = document.getElementById(`product-form-${this.dataset.section}`),
			e = t.querySelector('[name="add"]'),
			i = t.querySelector('[name="add"] > span'),
			s = document.getElementById(`price-${this.dataset.section}`);
		e && (i.textContent = window.variantStrings.unavailable, s && s.classList.add("visibility-hidden"))
	}
	getVariantData() {
		return this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent), this.variantData
	}
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
	constructor() {
		super(), this.updateSizesAvailability(), this.colorGalleries = document.querySelectorAll("[data-product-media-color]")
	}
	onVariantChange() {
		this.updateOptions(), this.updateSizesAvailability(), this.updateMasterId(), this.toggleAddButton(!0, "", !1), this.updatePickupAvailability(), this.removeErrorMessage(), this.currentVariant ? (this.updateMedia(), this.updateURL(), this.updateVariantInput(), this.renderProductInfo(), this.updateShareUrl()) : (this.toggleAddButton(!0, "", !0), this.setUnavailable())
	}
	updateMedia() {
    try {
      if (!this.currentVariant) {
        console.warn("[updateMedia] no currentVariant");
        return;
      }
      if (!this.currentVariant.featured_media) {
        console.warn("[updateMedia] currentVariant has no featured_media");
        return;
      }
  
      const mediaId = String(this.currentVariant.featured_media.id);
      const section = this.dataset.section;
      console.log("[updateMedia] mediaId:", mediaId, "section:", section);
  
      // 1) Intentar actualizar la galería principal (si existe)
      const gallerySelector = `#MediaGallery-${section}`;
      const gallery = document.querySelector(gallerySelector) || document.querySelector('[id^="MediaGallery-"]');
      if (gallery && typeof gallery.setActiveMedia === "function") {
        try {
          gallery.setActiveMedia(`${section}-${mediaId}`, true);
        } catch (e) {
          console.warn("[updateMedia] setActiveMedia error:", e);
        }
      } else {
        console.warn("[updateMedia] gallery not found or setActiveMedia missing for", gallerySelector);
      }
  
      // 2) Función para encontrar el modalContent (variantes de selector por fallback)
      const findModalContent = () => {
        return document.querySelector(`#ProductModal-${section} .product-media-modal__content`)
          || document.querySelector(`#ProductModal-${section}`)
          && document.querySelector(`#ProductModal-${section} .product-media-modal__content`)
          || document.querySelector('.product-media-modal__content')
          || null;
      };
  
      const modalContent = findModalContent();
      if (!modalContent) {
        console.warn("[updateMedia] modalContent not found immediately. Observando DOM por cambios...");
        // Esperar a que aparezca el modalContent (p. ej. si se renderiza después)
        const observer = new MutationObserver((mutations, obs) => {
          const mc = findModalContent();
          if (mc) {
            obs.disconnect();
            insertMediaIntoModal(mc, mediaId, gallery);
          }
        });
        observer.observe(document.body, { childList: true, subtree: true });
        return;
      }
  
      // 3) Inserta / trae la media al frente
      insertMediaIntoModal(modalContent, mediaId, gallery);
  
    } catch (err) {
      console.error("[updateMedia] unexpected error:", err);
    }
  
    // -------------------------
    // Helpers (se mantienen dentro del scope)
    // -------------------------
    function insertMediaIntoModal(modalContent, mediaId, gallery) {
      try {
        // Si ya existe dentro del modal, solo lo traemos al frente
        const existing = modalContent.querySelector(`[data-media-id="${mediaId}"]`);
        if (existing) {
          modalContent.prepend(existing);
          console.log("[updateMedia] existing media moved to front in modal:", mediaId);
          return;
        }
  
        // Buscar en la página un elemento con ese data-media-id (preferir dentro de la galería)
        let source = null;
        if (gallery) source = gallery.querySelector(`[data-media-id="${mediaId}"]`);
        if (!source) source = document.querySelector(`[data-media-id="${mediaId}"]`);
  
        if (!source) {
          console.warn("[updateMedia] no source element found for mediaId:", mediaId);
          return;
        }
  
        // Clonar (para no remover el original de la galería)
        const clone = source.cloneNode(true);
        // limpiar id para evitar conflictos
        clone.removeAttribute('id');
        // asegurar que quede visible en modal
        clone.style.display = 'block';
        modalContent.prepend(clone);
        console.log("[updateMedia] cloned media into modal:", mediaId);
      } catch (err) {
        console.error("[updateMedia] insertMediaIntoModal error:", err);
      }
    }
  }
	switchMediaGalleryColor() {
		this.optionLabels[0] && "Color" === this.optionLabels[0] ? (this.selectedColor = this.options[0], this.colorGalleries.forEach((t => {
			const e = this.selectedColor == t.dataset.productMediaColor ? "add" : "remove";
			t.classList[e]("product__media-wrapper--variant--active")
		}))) : console.warn("No Color galleries, so we do not switch color galleries")
	}
	updateSizesAvailability() {
		if (this.optionLabels || this.updateOptionLabels(), this.options || this.updateOptions(), !(this.optionLabels[0] && this.optionLabels[0].includes("Color") && this.optionLabels[1] && this.optionLabels[1].includes("Talla"))) return void console.warn("No Color + Size combination, so we do not update size availability");
		this.selectedColor = this.options[0], this.currentSizes = this.getVariantData().filter((t => t.option1 === this.options[0])), this.sizeAvailable = {};
		for (const t of this.currentSizes) this.sizeAvailable[t.option2] = t.available;
		this.querySelectorAll('input[name="Talla"]').forEach((t => {
			const e = t.value,
				i = this.querySelector(`label[for="${t.id}"]`),
				s = this.sizeAvailable[e] ? "remove" : "add";
			t.classList[s]("unavailable"), i.classList[s]("unavailable")
		}))
	}
	updateOptionLabels() {
		const t = Array.from(this.querySelectorAll("fieldset"));
		this.optionLabels = t.map((t => t.querySelector("[data-option-label]").innerText))
	}
	updateOptions() {
		const t = Array.from(this.querySelectorAll("fieldset"));
		this.options = t.map((t => Array.from(t.querySelectorAll("input")).find((t => t.checked)).value))
	}
}
customElements.define("variant-radios", VariantRadios);
const menuItem = document.querySelectorAll("[data-mobile-link]");
if (menuItem) {
	function getCookie(t) {
		let e = document.cookie.match(new RegExp("(?:^|; )" + t.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
		return e ? decodeURIComponent(e[1]) : void 0
	}
	menuItem.forEach((t => {
		t.addEventListener("click", (t => {
			let e = t.currentTarget.getAttribute("data-parent-category");
			document.cookie = `genderCategoryActive=${e}; path=/;`
		}))
	}));
	const e = document.querySelectorAll("[data-navigation-parent-id]"),
		i = document.querySelectorAll("[data-navigation-child-id]");
	if (null != getCookie("genderCategoryActive")) {
		let s = getCookie("genderCategoryActive");
		e.forEach((t => {
			t.getAttribute("data-navigation-parent-id").includes(s) ? t.classList.add("is-active") : t.classList.remove("is-active")
		})), i.forEach((t => {
			t.getAttribute("data-navigation-child-id").includes(s) ? t.classList.add("is-active") : t.classList.remove("is-active")
		}))
	} else e[0]?.classList.add("is-active"), i[0]?.classList.add("is-active")
}
const body = document.querySelector("body"),
	sectionHeader = document.querySelector(".excens-header-js"),
	closeMenuIcon = document.querySelector("[data-close-drawer]"),
	drawerContainer = document.getElementById("Details-menu-drawer-container"),
	summaryIcon = document.querySelector("summary.header__icon--summary");
closeMenuIcon && closeMenuIcon.addEventListener("click", (() => {
	body.classList.remove("overflow-hidden-tablet", "overflow-hidden-mobile"), drawerContainer.classList.remove("menu-opening"), summaryIcon.setAttribute("aria-expanded", "false"), setTimeout((() => {
		sectionHeader.classList.remove("menu-open"), drawerContainer.removeAttribute("open")
	}), 500)
}));
class CustomDownloadLink extends HTMLElement {
	constructor() {
		super(), this.link = this.querySelector("a"), this.link.addEventListener("click", this.onClickHandle.bind(this))
	}
	async onClickHandle(t) {
		t.preventDefault();
		let e = await fetch(this.link.href),
			i = await e.blob(),
			s = URL.createObjectURL(i),
			r = document.createElement("a");
		r.href = s, r.download = this.link.getAttribute("data-remote-title"), r.click()
	}
}
customElements.define("download-link", CustomDownloadLink);